import React, {FC, PropsWithChildren} from 'react';

export const UnderPaymentSlot: FC<PropsWithChildren> = ({children}) => {
  return <div slot="slot_under_payment_button">{children}</div>;
};
